module.exports = __webpack_public_path__ + "static/media/005-silver-cup.8205f590.png";